export const companyReducerName = "companies";
